import axios from "axios";
import authHeader from './utils/auth-header';

const API_URL = '/OppPortal/api/v1/files/';

class FileService {
    getClientFolders() {
        return axios.get(API_URL + "clients", {headers: authHeader()});
    }

    createClientFolders(name, subFolders, isNew) {
        return axios.post(API_URL + `client/${name}?isNew=${isNew}`, subFolders, {headers: authHeader()});
    }

    getFolderAccessByEmail(email) {
        return axios.get(API_URL + `access/all?emailManager=${email}`, {headers: authHeader()});
    }

    getFolderAccessByName(name) {
        return axios.get(API_URL + `access/all?folderName=${name}`, {headers: authHeader()});
    }

    giveFolderAccess(folder, portalIds) {
        return axios.post(API_URL + `access/${folder}`, portalIds, {headers: authHeader()});
    }

    updateFolderAccess(folder, portalIds) {
        return axios.put(API_URL + `access/${folder}`, portalIds, {headers: authHeader()});
    }

    uploadFiles(rootPath, mapFiles) {
        let user = JSON.parse(localStorage.getItem('user'));
        let formData = new FormData();
        Object.keys(mapFiles).forEach(key => {
            const file = mapFiles[key]
            formData.append('files', file);
        })
        formData.append('rootPath', rootPath);
        return axios.post(API_URL + `upload`, formData, {
            headers: {
                "Content-Type": "multipart/form-data",
                Authorization: 'Bearer ' + user.accessToken
            }
        });
    }

    deleteFile(path, folderName) {
        if (folderName) {
            return axios.delete(API_URL + `client?folderName=${folderName}`, {params: {path: path}, headers: authHeader()});
        }
        return axios.delete(API_URL + `client/`, {params: {path: path}, headers: authHeader()});
    }
}

export default new FileService();